import React, { useEffect, useState } from "react";
import ClayStepperNav from "@clayui/multi-step-nav";
import "./Stepper.css";

interface ObjectItems {
  name?: string;
}

interface StepperProps {
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  items: ObjectItems[];
  disabledSteps?: number[];
}

interface StepsState {
  complete: boolean;
  subTitle: string;
}

const Stepper: React.FC<StepperProps> = ({ step, setStep, items, disabledSteps = [] }) => {
  const [steps, setSteps] = useState<StepsState[]>([]);

  useEffect(() => {
    const tempData: StepsState[] = items.map((item, index) => ({
      active: index === step,
      complete: step > index,
      subTitle: item.name || "",
      title: item.name || "",
    }));
    setSteps(tempData);
  }, [items, step]);

  return (
    <section className="business-expansion-stepper step-wizard-main">
      <div className="business-expansion-stepper-div">
        <ClayStepperNav indicatorLabel="bottom">
          {steps.map(({ complete, subTitle }, i) => (
            <ClayStepperNav.Item
              aria-disabled
              active={i === step}
              complete={complete}
              expand={i + 1 !== steps.length}
              key={i}
            >
              <ClayStepperNav.Divider />
              <ClayStepperNav.Indicator
                complete={complete}
                label={1 + i}
                subTitle={subTitle}
              />
            </ClayStepperNav.Item>
          ))}
        </ClayStepperNav>
      </div>
    </section>
  );
};

export default Stepper;